document.addEventListener(
	'DOMContentLoaded',
	function () {
		// Define URLs and initial values
		const url = `${window.location.origin}/blog/wordpress/wp-admin/admin-ajax.php?action=`;
		const currentUrl = window.location.href;
		const action = 'loadPosts';
		let setUrl = true;
		let currentPage = 1;

		function loadMoreButton() {
			// Select 'Load More' button
			let loadMore = document.querySelector('#loadMorePosts');

			if (loadMore) {
				if (setUrl) loadMore.setAttribute('href', generatePageUrl(currentUrl, currentPage + 1));

				// Add click event to 'Load More' button
				loadMore.addEventListener('click', (e) => {
					e.preventDefault();
					currentPage++;

					// Get query attributes
					let queryData = document.querySelector('.post-listing__loadMore');
					const data = {
						numberPosts: cardCounter(queryData, loadMore),
						category: queryData.getAttribute('data-category'),
						postType: queryData.getAttribute('data-post-type'),
						nonce: queryData.getAttribute('data-nonce'),
						variant: queryData.getAttribute('data-variant'),
						cardVariant: queryData.getAttribute('data-card-variant'),
						filterBy: queryData.getAttribute('data-filter-by'),
						search: queryData.getAttribute('data-search'),
						order: queryData.getAttribute('data-order'),
					};

					if (setUrl) loadMore.setAttribute('href', generatePageUrl(currentUrl, currentPage + 1));

					// Load more posts
					loadMorePosts(data);
				});
			}
		}

		loadMoreButton();

		// AJAX request to load more posts
		function loadMorePosts(data) {
			fetch(url + action, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
				},
				body: new URLSearchParams(data).toString(),
			})
				.then((response) => response.text())
				.then((result) => {
					// Update post listing with new posts
					if (data.variant == 'archive' || data.variant == 'tags') {
						document.querySelector('.load-posts .post-listing__posts').innerHTML = result;
					} else {
						document.querySelector('.post-listing__posts').innerHTML = result;
					}
				})
				.catch((error) => {
					console.error('Error in AJAX request:', error);
				});
		}

		// Count and set limit to displayed posts
		function cardCounter(queryData, loadMore) {
			let qtdCard = 0;
			const variant = queryData.getAttribute('data-variant');
			if (variant === 'archive' || variant === 'tags') {
				qtdCard = document.querySelectorAll('.load-posts .post-listing__posts .card').length;
			} else {
				qtdCard = document.querySelectorAll('.post-listing__posts .card').length;
			}
			const maxPost = queryData.getAttribute('data-number-posts');
			let qtdLoadMore = queryData.getAttribute('data-number');
			qtdLoadMore = Number(qtdLoadMore);
			let numberPosts = qtdCard + qtdLoadMore;

			// Hide 'Load More' button if max posts reached
			if (numberPosts >= maxPost) {
				loadMore.classList.add('disabled');
				setUrl = false;
				loadMore.removeAttribute('href');
			}

			return numberPosts;
		}

		// Generate URL for pagination
		function generatePageUrl(base, page) {
			base = base.replace(/\/page\/\d+/, '');

			if (base.endsWith('/')) {
				base = base.slice(0, -1);
			}

			return `${base}/page/${page}`;
		}

		// Reinitialize load more button upon custom event
		document.addEventListener('LoadMoreReady', () => {
			loadMoreButton();
		});
	},
	false,
);
